import { render, staticRenderFns } from "./MpWithdraw.vue?vue&type=template&id=6c3fb80c&scoped=true"
import script from "./MpWithdraw.vue?vue&type=script&lang=js"
export * from "./MpWithdraw.vue?vue&type=script&lang=js"
import style0 from "./MpWithdraw.vue?vue&type=style&index=0&id=6c3fb80c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3fb80c",
  null
  
)

export default component.exports